import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento_mediagallerymetadata-module"
    }}>{`Magento_MediaGalleryMetadata module`}</h1>
    <p>{`The purpose of this module is to provide an ability to extract the metadata from file and populating Media Asset entity fields when an image is uploaded to Magento and also provide an ability to update the metadata stored in an image file.`}</p>
    <h2 {...{
      "id": "installation-details"
    }}>{`Installation details`}</h2>
    <p>{`For information about module installation in Magento 2, see `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/commerce-operations/installation-guide/tutorials/manage-modules.html"
      }}>{`Enable or disable modules`}</a>{`.`}</p>
    <h2 {...{
      "id": "extensibility"
    }}>{`Extensibility`}</h2>
    <p>{`Extension developers can interact with the Magento_MediaGalleryMetadata module. For more information about the Magento extension mechanism, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/plugins/"
      }}>{`Magento plug-ins`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/dependency-injection/"
      }}>{`The Magento dependency injection mechanism`}</a>{` enables you to override the functionality of the Magento_MediaGalleryMetadata module.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 100.4.5.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      